import React, { type ReactNode, useMemo } from 'react'

import { AttackGraphNodeBlastRadius } from 'components/scenarios/concurrent/AttackGraphNodeBlastRadius'
import { AttackGraphNodeTargetGlyph } from 'components/scenarios/concurrent/AttackGraphNodeTargetGlyph'
import { GraphNodeGlyphIcon } from 'components/scenarios/concurrent/GraphNodeGlyphIcon'
import { GraphNodeNameDuration } from 'components/scenarios/concurrent/GraphNodeNameDuration'
import { GraphNodeWrapper } from 'components/scenarios/concurrent/GraphNodeWrapper'
import {
  type GraphNodePath,
  isInfraAttackNode,
  serializeNodePathToId
} from 'components/scenarios/utils/graph'

import type { ScenarioPreview } from 'types/api/reliability-tests/preview'
import type { InfraAttackNode, GraphNode } from 'types/api/scenarios/scenario'

export const AttackGraphNode: React.FC<{
  allNodes: GraphNode[]
  isClickable?: boolean
  node: InfraAttackNode
  nodePath: GraphNodePath
  onClick?: (node: GraphNode) => void
  rowActions?: ReactNode
  scenarioPreview?: ScenarioPreview
  showTargetType?: boolean
}> = ({
  allNodes,
  isClickable = false,
  node,
  nodePath,
  onClick,
  rowActions = null,
  scenarioPreview,
  showTargetType = true
}) => {
  const allInfraNodes = useMemo(() => {
    return allNodes.filter(isInfraAttackNode)
  }, [allNodes])

  return (
    <GraphNodeWrapper
      data-testid={`infra-attack-graph-node-${serializeNodePathToId(nodePath)}`}
      details={
        <>
          <GraphNodeGlyphIcon node={node} />
          <GraphNodeNameDuration allInfraNodes={allInfraNodes} node={node} />
        </>
      }
      impact={
        <>
          <AttackGraphNodeTargetGlyph
            node={node}
            showTargetType={showTargetType}
          />
          <AttackGraphNodeBlastRadius node={node} />
        </>
      }
      isClickable={isClickable}
      node={node}
      rowActions={rowActions}
      scenarioPreview={scenarioPreview}
      onClick={onClick}
    />
  )
}
